import { integerDeclination } from 'utils';

export const formatAttachmentsCount = (count: number): string | undefined => {
  if (!count) {
    return undefined;
  }

  return `${count} ${integerDeclination(count, [
    'вложение',
    'вложения',
    'вложений',
  ])}`;
};
